import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-settings-migrate-workflow',
  standalone: false,
  templateUrl: './settings-migrate-workflow.component.html',
  styleUrls: ['./settings-migrate-workflow.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SettingsMigrateWorkflowComponent {

}
